import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ReportColumnsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ReportColumnsIcon = ({ className, ...props }: ReportColumnsIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.40039 10.25C10.1457 10.2502 10.7498 10.8543 10.75 11.5996V20.4004C10.7498 21.1457 10.1457 21.7498 9.40039 21.75H3.59961C2.85433 21.7498 2.25021 21.1457 2.25 20.4004V11.5996C2.25021 10.8543 2.85433 10.2502 3.59961 10.25H9.40039ZM20.4004 15.25C21.1457 15.2502 21.7498 15.8543 21.75 16.5996V20.4004C21.7498 21.1457 21.1457 21.7498 20.4004 21.75H14.5996C13.8543 21.7498 13.2502 21.1457 13.25 20.4004V16.5996C13.2502 15.8543 13.8543 15.2502 14.5996 15.25H20.4004ZM3.75 20.25H9.25V11.75H3.75V20.25ZM14.75 20.25H20.25V16.75H14.75V20.25ZM20.4004 2.25C21.1457 2.25021 21.7498 2.85434 21.75 3.59961V12.4004C21.7498 13.1457 21.1457 13.7498 20.4004 13.75H14.5996C13.8543 13.7498 13.2502 13.1457 13.25 12.4004V3.59961C13.2502 2.85433 13.8543 2.25021 14.5996 2.25H20.4004ZM14.75 12.25H20.25V3.75H14.75V12.25ZM9.40039 2.25C10.1457 2.25021 10.7498 2.85433 10.75 3.59961V7.40039C10.7498 8.14567 10.1457 8.74979 9.40039 8.75H3.59961C2.85433 8.74979 2.25021 8.14567 2.25 7.40039V3.59961C2.25021 2.85433 2.85433 2.25021 3.59961 2.25H9.40039ZM3.75 7.25H9.25V3.75H3.75V7.25Z"
      fill="currentColor"
    />
  </svg>
);

export default ReportColumnsIcon;
